<template>
	<div class="product">
		<div class="contain">
			<Panel title="泰康养老云平台" class="barOne tree">
				<p class="wow slideInUp">源自泰康养老社区的高品质服务，持续迭代以满足泰康大健康产业生态开放需求，由面向民政机关的“互联网+区域养老云平台”和面向医养结合特色养老服务机构的“SaaS平台(泰养云)”组成。</p>
				<img src="../../assets/images/img_6.png" style="width:536px" alt="" />
			</Panel>
			<Panel title="养老信息化痛点" style="padding-top:50px">
				<img src="../../assets/images/img_30.png" style="width:650px;margin-top:30px" alt="" class="wow slideInUp"/>
			</Panel>
			<Panel title="云计算平台架构" class="barOne barThree tree">
				<p class="wow slideInUp">泰康养老云基于自有知识产权，通过云计算架构，集IaaS（基础设施即服务）、PaaS（平台即服务）、SaaS（软件即服务）于一体，以老年电子健康档案为核心，涵盖居住管理、评估管理、合同管理、照护管理、康复系统、费用管理、订单管理、志愿者系统等应用和支撑服务功能。</p>
				<img src="../../assets/images/img_7.png" alt="" style="width:707px" class="wow slideInUp"/>
			</Panel>
			<Panel title="产品生态" class="barTwo">
				<img src="../../assets/images/img_8.png" alt="" style="width:725px" class="wow slideInUp"/>
			</Panel>
			<Panel title="泰养云网页端" class="barOne barThree ">
				<img src="../../assets/images/img_9.png" style="width:462px;margin-top:15px" alt="" class="wow slideInUp"/>
				<div class="tagBar wow slideInUp" style="width:640px">
					<div class="tagC tagC_1">
						<span>营销管理</span>
						<span>居住管理</span>
						<span>评估管理</span>
						<span>照护管理</span>
						<span>健康管理</span>
						<span>客户服务</span>
						<span>订单管理</span>
						<span>档案管理</span>
						<span>费用管理</span>
						<span>运营报表</span>
					</div>
				</div>
			</Panel>
			<Panel title="泰养云移动端" class="barTwo wow slideInUp">
				<img src="../../assets/images/img_31.png" alt="" style="width:900px;margin-top:-30px" />
				<div class="tagBar">
					<div class="tagC wow slideInUp">
						<span>服务计划</span>
						<span>服务任务</span>
						<span>评估量表</span>
						<span>体征采集</span>
						<span>人脸信息</span>
						<span>工作记录</span>
						<span>护理执行</span>
						<span>满意度调查</span>
					</div>
				</div>
			</Panel>
			<Panel title="泰养云微信端" class="barOne barThree">
				<img src="../../assets/images/icon_wechat_1.png" style="width:60px;margin-bottom:40px;" alt="" class="wow slideInUp"/>
				<img src="../../assets/images/img_11.png" style="width:576px;" alt="" class="wow slideInUp"/>
				<div class="tagBar wow slideInUp" style="width:640px" >
					<div class="tagC tagC_1">
						<span>预约参观</span>
						<span>自我评估</span>
						<span>机构介绍</span>
						<span>每日食谱</span>
						<span>月结账单</span>
						<span>平台新闻</span>
						<span>健康管理</span>
						<span>经营日报</span>
						<span>机构设置</span>
						<span>用户绑定</span>
					</div>
				</div>
			</Panel>
			<Panel title="泰养云增值服务" class="barTwo addService">
				<div class="c_service wow slideInUp">
					<swiper :options="swiperOption">
						<swiper-slide>
							<dl>
								<dt><img src="../../assets/images/icon_jigou.png" alt="" /></dt>
								<dd>机构信息规划咨询</dd>
							</dl>
							<dl>
								<dt><img src="../../assets/images/icon_zhengfu.png" alt="" /></dt>
								<dd>政府养老补贴对接</dd>
							</dl>
							<dl>
								<dt><img src="../../assets/images/icon_bao.png" alt="" /></dt>
								<dd>长期护理保险对接</dd>
							</dl>
							<dl>
								<dt><img src="../../assets/images/icon_hangye.png" alt="" /></dt>
								<dd>产业生态平台对接</dd>
							</dl>
							<dl>
								<dt><img src="../../assets/images/icon_zhinengshebei.png" alt="" /></dt>
								<dd>智能设备平台对接</dd>
							</dl>
						</swiper-slide>
						<swiper-slide>
							<dl>
								<dt><img src="../../assets/images/icon_shuju.png" alt="" /></dt>
								<dd>运营数据大屏展示</dd>
							</dl>
							<dl>
								<dt><img src="../../assets/images/icon_shendu.png" alt="" /></dt>
								<dd>深度按需功能定制</dd>
							</dl>
							<dl>
								<dt><img src="../../assets/images/icon_yunying.png" alt="" /></dt>
								<dd>运营流程优化改造</dd>
							</dl>
							<dl>
								<dt><img src="../../assets/images/icon_liansuo.png" alt="" /></dt>
								<dd>连锁经营集团管控</dd>
							</dl>
							<dl>
								<dt><img src="../../assets/images/icon_hangye.png" alt="" /></dt>
								<dd>行业宣传网络营销</dd>
							</dl>
						</swiper-slide>
						<swiper-slide>
							<dl>
								<dt><img src="../../assets/images/icon_zhiyuanzhe.png" alt="" /></dt>
								<dd>志愿者&时间银行</dd>
							</dl>
						</swiper-slide>
						<div class="swiper-button-prev" slot="button-prev" style="outline:none;border:none;"></div>
						<div class="swiper-button-next" slot="button-next" style="outline:none;border:none;"></div>
					</swiper>
				</div>
			</Panel>
			<Panel title="泰康养老云" class="tkYun">
				<p class="wow slideInUp">专注中国养老机构的数据服务平台</p>
			</Panel>
			<Panel title="我们的优势" class="barTwo advatage">
				<div class="wow slideInUp">
					<dl>
						<dt></dt>
						<dd>全云方案</dd>
						<dd>泰康养老云依托泰康云金融级别的IaaS云服务、两地三中心保障数据网络信息安全，实现业务数据妥善保护。</dd>
					</dl>
					<dl>
						<dt></dt>
						<dd>科技创新</dd>
						<dd>泰康养老云聚焦科技创新与多方知名院校合作，已获得多项专利授权，如智能红外养老监护系统。</dd>
					</dl>
					<dl>
						<dt></dt>
						<dd>产业标杆</dd>
						<dd>泰康全国布局十二城，实现城际社区资源共享与信息联动，是国家金卡工程物联网应用智慧养老示范园，正在推动新时代的养老革命。</dd>
					</dl>
					<dl>
						<dt></dt>
						<dd>行业标准</dd>
						<dd>作为多项标准化课题牵头单位，泰康积极参与并承接金融保险、民政、人社及卫健部门的医养标准化课题相关工作。</dd>
					</dl>
					<dl>
						<dt></dt>
						<dd>生态体系</dd>
						<dd>泰康通过与合作伙伴深度合作，建立涵盖健康保险、临床医疗、健康管理、养老服务、供应链体系、互联网医疗的大健康产业生态体系。</dd>
					</dl>
				</div>
			</Panel>
		</div>
		<back-top></back-top>
	</div>
</template>

<script>
	import ApiSetting from '../../assets/js/interface'
	import Panel from '../public/panel.vue'
	import backTop from '../public/backTop.vue'

	import '../../assets/css/swiper.css'
	import {swiper,swiperSlide} from 'vue-awesome-swiper'
//	import Swiper from 'swiper'
 // import 'swiper/dist/css/swiper.min.css'
	export default {
		name: 'product',
		props: [],
		data() {
			return {
				swiperOption:{
					notNextTick:true,
					navigation:{
						nextEl:'.swiper-button-next',
						prevEl:'.swiper-button-prev'
					}
				}
			};
		},
		components: {
			Panel,
			swiper,
			swiperSlide,
			backTop,
		},
		mounted() {
			//动画初使化
			new this.$WOW.WOW({live: false}).init();
		},
		watch: {

		},
		computed: {

		},
		created() {

		},
		methods: {

		}
	}
</script>

<style lang="less" scoped>
	@import '../../assets/css/common';
	.product{
		padding-top:.1px;

		.contain {
			margin-top:80px;
			.tagBar{//底部标签样式
						width:598px;
						margin:0 auto;
						margin-top:50px;
						.tagC{
							width:608px;
							&:after{
								content:"";
								display:block;
								height:0;
								visibility: hidden;
								clear:both;
							}
							span{
								float:left;
								width:142px;
								height:49px;
								line-height:49px;
								color:#fff;
								font-size:22px;
								text-align:center;
								border:1px solid #fff;
								border-radius:8px;
								box-sizing:border-box;
								margin-right:10px;
								margin-bottom:10px;
							}
						}
						.tagC.tagC_1{
							width:650px;
							span{
								width:120px;
							}
						}
			}
			p{
				font-size:16px;
				line-height: 26px;
			}
			.barOne{
				// background:@backgroundColor;
				/deep/.content{
					overflow:visible;
					padding-bottom:0px;
					padding-top:80px;
					h4,p{
						color:#fff;
					}
					p{
						margin-bottom:55px;
					}
					img{
						display:block;
						width:45%;
						margin:0 auto;
						margin-bottom:-13.1%;
					}
				}
			}
			.barOne.barThree{
				background:url(../../assets/images/img_10.png) no-repeat 0 0;
				background-size:100% 100%;
				/deep/.content{
					padding-bottom:80px;
					img{
						display:block;
						width:59%;
						margin:0 auto;
					}
				}
			}
			.barTwo{
				/deep/.content{
					img{
						display:block;
						width:59%;
						margin:0 auto;
					}
				}
				.tagBar{
					margin-top:0px;
					.tagC{
						span{
							border:1px solid #40B7AF;
							color:#666;
						}
					}
				}
			}
			.tkYun{
				background:url(../../assets/images/img_5.png) no-repeat 0 0;
				padding:5% 0;
				background-size:100% 100%;
				opacity: 0.8;
				/deep/.content{
					padding-top:0;
					padding-bottom:0;
					h4{
						font-size:50px;
						color:#fff;
					}
					p{
						font-size:36px;
						color:#fff;
						margin-top:20px;
						line-height: 36px;
					}
				}
			}
			.barTwo.advatage{
				/deep/.content{
					padding:80px 0;
					div{
						min-width:1156px;
						margin:0 auto;
						dl{
							height:54px;
							line-height:54px;
							margin-bottom:30px;
							dt,dd{
								float:left;
								margin-right:15px;
								height:100%;
							}
							dt{
								width:54px;
								background:url(../../assets/images/icon_quanfangwei.png) no-repeat center center;
							}
							dd:nth-of-type(1){
								font-size: 22px;
								color: #46B8B1;
								// font-weight:bold;
							}
							dd:nth-of-type(2){
								background: #F5F5F5;
								border-radius:8px;
								padding:0 16px;
								font-size: 16px;
								color: #666666;
								letter-spacing: 0.5px;
								margin-right:0px;
							}
						}
						dl:nth-of-type(2){
							dt{
								background:url(../../assets/images/icon_keji.png) no-repeat center center;
							}
						}
						dl:nth-of-type(3){
							dt{
								background:url(../../assets/images/icon_chanye.png) no-repeat center center;
							}
						}
						dl:nth-of-type(4){
							dt{
								background:url(../../assets/images/icon_biaozhun.png) no-repeat center center;
							}
						}
						dl:nth-of-type(5){
							dt{
								background:url(../../assets/images/icon_shengtai.png) no-repeat center center;
							}
						}
					}
				}
			}
			.barTwo.addService{
				height:600px;
				background:url(../../assets/images/addService.png) no-repeat 0 0;
				background-size:100% 100%;
				/deep/.content{
					padding:0;
					padding-top:100px;
					.c_service{
						height:260px;
						margin-top:50px;
						.swiper-container{
							// .swiper-slide{
							// 	padding-left:60px;
							// }
							// height:100%;
							dl{
								float:left;
								margin-right:20px;
								height:100%;
								width:200px;
								background-color: #FFFFFF;
								box-shadow: 0 2px 16px 0 #E8E8E8;
								border-radius: 6px;
								dt{
									padding-top:0.1px;
									width:86px;
									height:86px;
									margin:0 auto;
									margin-top:48px;
									img{
										width:100%;
									}
								}
								dd{
									font-size: 20px;
									color: #666666;
									text-align:center;
									height:20px;
									line-height:20px;
									margin-top:40px;
								}
							}
						}
					}
				}
			}
			.barOne.tree{
				background:url(../../assets/images/img_12.png) no-repeat 17% 65%,url(../../assets/images/img_13.png) no-repeat 35% 11%,url(../../assets/images/img_14.png) no-repeat 77% 70.5%,url(../../assets/images/img_bg.png) repeat 0 0;
			}
			.barOne.barThree.tree{
				background:url(../../assets/images/img_12.png) no-repeat 10% 92%,url(../../assets/images/img_13.png) no-repeat 35% 11%,url(../../assets/images/img_14.png) no-repeat 83% 93%,url(../../assets/images/img_bg.png) repeat 0 0;
			}
		}
	}
</style>
<style lang="less">
// #app{
// 	overflow-y:auto;
// }
body,html{
	transition:all 1s;
}
.product{
	.swiper-button-prev{
		background:url(../../assets/images/icon_left.png) no-repeat left center;
	}
	.swiper-button-next{
		background:url(../../assets/images/icon_right.png) no-repeat right center;
	}
	.swiper-container{
		height:100%;
		.swiper-wrapper{
			padding-left:60px;
			height:100%;
			.swiper-slide{
				height:100%;
			}
		}
	}
}
	
</style>



// WEBPACK FOOTER //
// src/components/product/Product.vue